<template>
    <b-container>
        <h1 class="text-center pt-4 pb-4">{{ $t("title.groupAssignment") }}</h1>

        <div v-if="groups.length > 0">
            <b-row>
                <b-col>
                    <b-alert show variant="info" class="mt-4">
                        <b-alert show variant="danger" class="mt-4">
                            <p>{{ $t("info.plannerGroupingMaxLength") }}</p>
                            <p>{{ $t("label.numberOfGroupSelect") }} : {{ teamSelect.length }}</p>
                        </b-alert>
                        <hr>
                        <div
                            v-if="(teamSelect.length > 0 && teamSelect.length < maxPlannerGroupLength)">
                            <b-form @submit="onSubmit">
                                <b-form-input v-model.trim="$v.groupingName.$model"
                                    :placeholder="$t('action.chooseGroupingName')"></b-form-input>
                                <div class="text-danger" v-if="!$v.groupingName.required && $v.groupingName.$dirty">{{
                                    $t("info.required")
                                }}</div>
                                <div class="text-danger" v-if="!$v.groupingName.maxLength && $v.groupingName.$dirty">{{
                                    $t("info.maxLength", [50]) }}
                                </div>

                                <div>
                                    <b-button class="mt-4" type="submit" variant="success" :disabled="disabled">{{
                                        $t("action.submit") }}</b-button>
                                    <b-button v-if="groupingItem" class="mt-4 mr-4 float-right" variant="danger"
                                        @click="removeGroupingItem()">{{
                                            $t("action.remove")
                                        }}</b-button>
                                </div>
                            </b-form>
                        </div>
                    </b-alert>
                </b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col sm="4" class="mt-2">
                    <b-form-select v-model="perPage" :options="options"></b-form-select>
                </b-col>
                <b-col sm="4" class="mt-2">
                    <b-form-input v-model="search" :placeholder="$t('action.search')"></b-form-input>
                    <b-button variant="link" @click="resetTable()">{{
                        $t("action.reset")
                        }}</b-button>
                </b-col>
                <b-col sm="4" class="mt-2">
                    <div>{{ $t("label.tablesize") }} {{ rows }}</div>
                </b-col>
            </b-row>
            <b-row class="pt-4">
                <b-col class="lgTable">
                    <b-table id="groupTable" stacked="lg" bordered :fields="myfields" :items="items"
                        :per-page="perPage"
                        :current-page="currentPage">
                        <template v-slot:cell(assignment)="row">
                            <b-button variant="link" class="ml-2" size="sm"
                                @click="openmodal('membersModal', row.item)">{{
                                    $t("action.viewMembers") }}</b-button>
                        </template>
                        <template v-slot:cell(details)="row">
                            <b-button :variant="row.item.variant" class="ml-2" size="sm"
                                @click="chooseGroup(row.item)">{{
                                    $t("action.choose") }}</b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <b-row class="pt-4">
                <b-col sm="6" class="mt-2">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                        aria-controls="groupTable"></b-pagination>
                </b-col>
            </b-row>
        </div>

        <b-modal id="membersModal" :title="$t('action.viewMembers')" hide-footer>
            <ChooseMembers :rowItem="rowItem" :showBtn="false" modalid="membersModal" />
        </b-modal>

        <div v-if="spinner" class="text-center">
            <b-spinner style="width: 3rem; height: 3rem" class="spinner" variant="success" label="Spinning"
                disabled="labelStatus"></b-spinner>
        </div>

        <div v-if="error" class="pt-4">
            <b-alert show variant="danger">
                <p>{{ error }}</p>
            </b-alert>
        </div>
    </b-container>
</template>

<script>
import axios from "axios";
import { globalF } from "../../Helpers";
import { required, maxLength } from 'vuelidate/lib/validators';
import ChooseMembers from "../../modal/ChooseMembers.vue";

export default {
    mixins: [globalF],
    props: ['groupingItem', 'modalid'],
    data() {
        return {
            error: "",
            spinner: false,
            disabled: false,
            AllGroups: [],
            groups: [],
            sortBy: "NOMDIV",
            sortDesc: false,
            perPage: 10,
            currentPage: 1,
            search: "",
            options: [
                { value: 10, text: "10" },
                { value: 25, text: "25" },
                { value: 50, text: "50" },
                { value: 100, text: "100" },
            ],
            teamSelect: [],
            rowItem: null,
            maxPlannerGroupLength: 26,
            groupType: null,
            groupingName: this.getData("GroupingName", ""),
            groupingListAssociation: []
        };
    },
    validations() {
        return {
            groupingName: {
                required,
                maxLength: maxLength(75)
            }
        }
    },
    mounted() {
        this.getBuildingList();
    },
    computed: {
        user: function () {
            return this.$store.getters.getGraphUser;
        },
        url: function () {
            return this.getUrl();
        },
        rows() {
            return this.items.length;
        },
        items: function () {
            let mydatalist = this.groups;
            let search = this.search.toLowerCase();
            return mydatalist.filter(
                (p) =>
                    p.NOMDIV.toString().toLowerCase().includes(search) ||
                    p.GroupName.toString().toLowerCase().includes(search)
            );
        },
        myfields: function () {
            return [
                {
                    key: "NOMDIV",
                    sortable: true,
                    label: this.$t("label.building"),
                },
                {
                    key: "GroupName",
                    sortable: true,
                    label: this.$t("label.nameOfTheGroup"),
                },
                {
                    key: "UniqueId",
                    sortable: true,
                    label: "UniqueId",
                },
                {
                    key: "Language",
                    sortable: true,
                    label: this.$t("label.language"),
                },
                { key: "assignment", label: this.$t("action.chooseMembers") },
                { key: "details", label: this.$t("label.edit") },
            ];
        },
    },
    methods: {
        getData: function (type, propertyValue) {
            let groupingItem = this.groupingItem;
            if (groupingItem) {
                propertyValue = groupingItem[type];
            }
            return propertyValue;
        },
        resetTable: function () {
            this.search = "";
        },
        getBuildingList() {
            this.spinner = true;
            let urls = this.$store.getters.getUrlsList;
            let url = urls[process.env.VUE_APP_WHERE].json;
            let idGrouping = this.groupingItem ? this.groupingItem.Id : 0;

            let promise = this.validateToken();
            promise.then(() => {
                axios
                    .post(
                        url,
                        { request: "getGroupAssignmentRessource", idGrouping: idGrouping },
                        { headers: { "Content-Type": "application/json" } }
                    )
                    .then((response) => {
                        this.spinner = false;
                        this.groupingListAssociation = response.data.groupingListAssociation;

                        let teamBuildings = response.data.teamBuildings;
                        let mapTeamBuilding = teamBuildings.map((t) => {
                            t.groupType = "building";
                            return t;
                        });
                        let groups = mapTeamBuilding;
                        let groupMembersList = this.$store.getters.getGroupMembersList;
                        this.groups = groups.map((b) => {
                            b.members = "";
                            b.membersList = [];
                            if (groupMembersList.length > 0) {
                                let members = groupMembersList.find(
                                    (m) => m.rowItem.GroupId === b.GroupId
                                );
                                if (members) {
                                    let membersList = members.members.map((m) => m.displayName);
                                    b.members = membersList.toString();
                                    b.membersList = members.members;
                                }
                            }
                            if (this.teamSelect.length > 0) {
                                let find = this.teamSelect.find((t) => t.GroupId === b.GroupId);
                                if (find) {
                                    b.variant = "success";
                                } else {
                                    b.variant = "outline-success";
                                }
                            } else {
                                b.variant = "outline-success";
                            }
                            return b;
                        });

                        this.AllGroups = groups;

                        if (this.groupingListAssociation.length > 0) {
                            this.findAndSetTeamSelect(response.data.groupingListAssociation);
                        }
                    })
                    .catch(() => {
                        this.spinner = false;
                        this.error = this.$t("info.errorgeneric");
                    });
            });
        },
        findAndSetTeamSelect(plannerGroupingAssociationList) {
            for (let i = 0; i < plannerGroupingAssociationList.length; i++) {
                let groupingAssociation = plannerGroupingAssociationList[i];
                let group = this.groups.find(g => g.Id === groupingAssociation.IdGroupBuilding);
                if (group) {
                    this.chooseGroup(group);
                }
            }
        },
        chooseGroup: function (group) {
            let tableInfo = this.groups;
            let teamSelect = this.teamSelect;

            let find = teamSelect.find((t) => t.GroupId === group.GroupId);
            if (find) {
                this.teamSelect = teamSelect.filter((t) => t.GroupId !== group.GroupId); //s'il est là je l'enlève
                this.groups = tableInfo.map((g) => {
                    if (g.GroupId === find.GroupId) {
                        g.variant = "outline-success"; //je remet le bouton outline-success
                    }
                    return g;
                });
            } else {
                this.teamSelect.push(group); //s'il n'est pas là je l'ajoute
                this.groups = tableInfo.map((g) => {
                    if (g.GroupId === group.GroupId) {
                        g.variant = "success"; //je met le bouton success
                    }
                    return g;
                });
            }

            this.groups.sort((a, b) => {
                if (a.variant > b.variant) {
                    return -1;
                }
                if (a.variant < b.variant) {
                    return 1;
                }
                return 0;
            });
        },
        onSubmit(evt) {
            evt.preventDefault();
            this.error = "";
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.disabled = true;
                this.spinner = true;

                this.error = "";
                this.spinner = true;
                let request = this.groupingItem ? "updatePlannerGrouping" : "addPlannerGrouping";
                let id = this.groupingItem ? this.groupingItem.Id : 0;

                let obj = {
                    request: request,
                    groupList: this.teamSelect,
                    groupingName: this.groupingName,
                    Id: id
                };

                axios
                    .post(this.url, obj, {
                        headers: { "Content-Type": "application/json" },
                    })
                    .then(() => {
                        this.spinner = false;
                        this.$bvModal.hide(this.modalid);
                    })
                    .catch(() => {
                        this.spinner = false;
                        this.error = this.$t("info.errorgeneric");
                    });
            }
        },
        removeGroupingItem() {
            this.disabled = true;
            this.spinner = true;

            this.error = "";
            this.spinner = true;
            let request = "removePlannerGrouping";
            let id = this.groupingItem ? this.groupingItem.Id : 0;

            let obj = {
                request: request,
                groupList: this.teamSelect,
                groupingName: this.groupingName,
                Id: id
            };

            axios
                .post(this.url, obj, {
                    headers: { "Content-Type": "application/json" },
                })
                .then(() => {
                    this.spinner = false;
                    this.$bvModal.hide(this.modalid);
                })
                .catch(() => {
                    this.spinner = false;
                    this.error = this.$t("info.errorgeneric");
                });

        },
        setNextPage(page) {
            this.$emit("changePage", page);
        },
        openmodal: function (id, rowItem) {
            this.rowItem = rowItem;
            this.$bvModal.show(id);
        },
    },
    components: {
        ChooseMembers
    },
};
</script>
